<!-- <div class="overlay">
  <div class="coming-soon-modal">
    <div class="icon-wrapper">
      <i class="bi bi-rocket-takeoff"></i>
    </div>
    <h2>Coming Soon!</h2>
    <p>Personalized guidance for higher education, entrance exams, and global study opportunities all in one place.</p>
    <button class="btn-add w-100 mb-2" (click)="close()">Got it</button>
  </div>
</div> -->

<section class="coming-soon">
  <div class="coming-soon__card">
    <div class="coming-soon__icon">
      <span class="material-icons">schedule</span>
    </div>
    <h1 class="coming-soon__title">Higher Studies</h1>
    <span class="coming-soon__badge">Coming Soon!</span>
    <p class="coming-soon__subtitle"> Personalized guidance for higher education, entrance exams, and abroad study opportunities all in one place.</p>
  </div>
</section>